

import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { Provider } from 'react-redux';
import store from '../slices/store'; 
import Splash from './Splash';


const domain = window.ENV?.AUTH0_DOMAIN;
const clientId = window.ENV?.AUTH0_CLIENT_ID;
const audience = window.ENV?.AUTH0_AUDIENCE;




console.log("domain:", domain);
console.log("clientId:", clientId);
console.log("audience:", audience);




const authParams = { 
    redirect_uri: window.location.origin,
    audience: audience,
    // offline_access → Auth0 issues a refresh token, so getAccessTokenSilently
    // can renew from localstorage instead of a hidden-iframe trip to Auth0.
    scope: "openid profile email offline_access"
};



const App = () => {
        
    // Clear Auth0 cache if port has changed to prevent redirect issues
    const currentPort = window.location.port || '80';
    const lastPort = localStorage.getItem('app_port');
    
    if (lastPort && lastPort !== currentPort) {
        console.log(`🔄 Port changed from ${lastPort} to ${currentPort} - clearing Auth0 cache`);
        // Clear all Auth0-related items from localStorage
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith('@@auth0')) {
                localStorage.removeItem(key);
            }
        });
    }
    
    localStorage.setItem('app_port', currentPort);
    
    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            authorizationParams={authParams}
            useRefreshTokens={true}
            cacheLocation="localstorage"
            onRedirectCallback={(appState) => {
                // Auth0 handles the redirect
            }}
        >
            <Provider store={store}>
                <Splash />
            </Provider>
        </Auth0Provider>
    );
};






export default App;